import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize, map, take } from 'rxjs/operators';
import { UtilitiesService } from 'src/app/core/services/utilities.service';
import { environment } from 'src/environments/environment';
import { API_URL } from '../enums/api-enums';
import { Profile } from '../model/profile.model';
import { EventManagerService } from './../../core/services/event-manager.service';
import { GetAllResponse, SingleResponse } from './../model/restful-api.model';
import { AUTHORIZED } from '../components/layout-header';

@Injectable({
  providedIn: 'root'
})

export class ProfileService {
  profile: GetAllResponse<Profile>;
  profileInfo: BehaviorSubject<GetAllResponse<Profile>> = new BehaviorSubject<GetAllResponse<Profile>>(null);
  constructor(
    private http: HttpClient,
    private utilities: UtilitiesService,
    private eventManager: EventManagerService) { }

  getProfileUserLast(): Observable<GetAllResponse<Profile>> {
    const url = environment.portalURL + API_URL.USER_PROFILE_URL + '?login=true';
    return this.utilities.req.httpGet<GetAllResponse<Profile>>(url);
  }
  // data type is wrong 
  getProfileUser(): Observable<GetAllResponse<Profile>> {
   return this.profileInfo.asObservable();
  }

  getUserProfile():Observable<Profile>{
    return this.profileInfo.asObservable().pipe(
      take(1),
      map(dataArray => (dataArray as any) as SingleResponse<Profile>),
      map(singleData => {return singleData.data})
    )
  }

  requestProfileUserAccess(body): Observable<GetAllResponse<Profile>> {
    const url = environment.portalURL + API_URL.USER_PROFILE_URL + '/supplier/id';
    return this.utilities.req.httpPut<GetAllResponse<Profile>>(url, body);
  }

  public initUserContext(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      const userName = localStorage.getItem(btoa('userName'));
      this.getProfileUserLast().pipe(finalize(() => { resolve(true); })).subscribe((res: any) => {
        if (res.data.roles.findIndex(i => i === 'GUEST') === -1) {
          if (!sessionStorage.getItem(btoa('showBanner'))) {
            sessionStorage.setItem(btoa('showBanner'), btoa('true'));
          }
          const profile = new Profile(res.data);
          localStorage.setItem(btoa('userName'), btoa(unescape(encodeURIComponent(`${profile.firstName} ${profile.lastName}`))));
          localStorage.setItem(btoa('role'), btoa(profile.roles.toString()));
          localStorage.setItem(btoa('isRSP'), btoa(res.data.authorized.some(i => i === AUTHORIZED.RSP) ? 'true' : 'false'));
          this.profileInfo.next(res);
        } else {
          localStorage.removeItem(btoa('userName'));
          localStorage.removeItem(btoa('role'));
          localStorage.removeItem(btoa('isRSP'));
          if (userName) {
            window.location.href = '/logout';
          }
        }
      }, (err) => {
        localStorage.removeItem(btoa('userName'));
        localStorage.removeItem(btoa('role'));
        localStorage.removeItem(btoa('isRSP'));
      });
    });
  }

  countVisitor(user: string) {
    return this.utilities.req.httpPost(environment.portalURL + '/visitor', {uid: user});
  }

  getIp() {
    return this.utilities.req.httpGet<string>('https://jsonip.com');
  }

}

